import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { PesticidesBlock } from '../../components/chemistry/Pesticides/index'

const PesticidesPage: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>Пестициды</title>
            </Helmet>
            <PesticidesBlock />

        </>
    );
};

export default PesticidesPage;
